import script from "./ActivationLinkDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationLinkDialog.vue?vue&type=script&setup=true&lang=js"

import "./ActivationLinkDialog.vue?vue&type=style&index=0&id=7afce069&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7afce069"]])

export default __exports__